import React, { useRef, useState } from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { CustomAutocomplete } from "../../../../../../CustomAutocomplete";
import { CheckPropertyLockAPI } from "../../../../../../../../Services";
import { CustomInput } from "../../../../../../CustomInput";
import { CustomRangeSlider } from "../../../../../../CustomRangeSlider";

// styles
import useStyles from "./styles";

const MyLeadUnitDetailsFields = ({
  data,
  state,
  selected,
  getAllProperty,
  onStateChangeHandler,
  onSelectedChangeHandler,
  setSelected,
  setState,
  translate,
}) => {
  const styles = useStyles();
  const searchTimer = useRef(null);
  const [isOpenPropertyLockMangaement, setIsOpenPropertyLockMangaement] =
    useState(false);

  return (
    <Box className={styles.wrapperMyLeadUnitDetailsFields}>
      {state.leadClassId &&
        (state.leadClassId === 1 || state.leadClassId === 2) && (
          <>
            <Box className={styles.containerItem}>
              <Typography className={styles.containerTitle}>
                {translate("Proprety-name")}*
              </Typography>
              <CustomAutocomplete
                placeholder={translate("Select")}
                selectedValues={selected.property || null}
                options={data.property}
                displayLabel={(option) => option.property_name || ""}
                renderOption={(option) =>
                  (
                    <span>
                      {" "}
                      {option.property_name}{" "}
                      {(option &&
                        option.property_plan !== undefined &&
                        (`      (      ${
                          (option &&
                            option.property_plan &&
                            option.property_plan.lookupItemName) ||
                          ""
                        }      ) ` ||
                          "")) ||
                        ""}
                    </span>
                  ) || ""
                }
                onChange={async (e, newValue) => {
                  if (newValue && newValue.id) {
                    const checkPropertyIsLock = await CheckPropertyLockAPI(
                      newValue.id
                    );
                    if (checkPropertyIsLock) {
                      const newState = {
                        ...state,
                        propertyId: null,
                        unitTypeId: null,
                        cityId: null,
                        districtId: null,
                        communityId: null,
                      };
                      const newSelected = {
                        ...selected,
                        property: null,
                        unitType: null,
                      };
                      setSelected({ id: "edit", value: newSelected });
                      setState({ id: "edit", value: newState });
                      setIsOpenPropertyLockMangaement(true);
                      return;
                    }
                  }
                  onSelectedChangeHandler("property", newValue || null);
                  onSelectedChangeHandler("unitType", null);
                  onStateChangeHandler("unitTypeId", null);
                  onStateChangeHandler(
                    "propertyId",
                    (newValue && newValue.id) || null
                  );
                  onStateChangeHandler(
                    "cityId",
                    (newValue &&
                      newValue &&
                      newValue.city &&
                      newValue.city.lookupItemId) ||
                      null
                  );
                  onStateChangeHandler(
                    "districtId",
                    (newValue &&
                      newValue &&
                      newValue.district &&
                      newValue.district.lookupItemId) ||
                      null
                  );
                  onStateChangeHandler(
                    "communityId",
                    (newValue &&
                      newValue &&
                      newValue.community &&
                      newValue.community.lookupItemId) ||
                      null
                  );
                }}
                onInputKeyUp={(e) => {
                  const { value } = e.target;
                  if (searchTimer.current) clearTimeout(searchTimer.current);
                  searchTimer.current = setTimeout(() => {
                    getAllProperty(value);
                  }, 500);
                }}
              />
            </Box>
            <Divider />
          </>
        )}
      {((state.leadClassId &&
        (state.leadClassId === 3 || state.leadClassId === 4)) ||
        !state.leadClassId) && (
        <>
          <Box className={styles.containerItem}>
            <Typography className={styles.containerTitle}>
              {translate("Proprety-name")}*
            </Typography>
            <CustomAutocomplete
              placeholder={translate("Select")}
              selectedValues={selected?.property || null}
              options={data?.property || []}
              displayLabel={(option) => option?.property_name || ""}
              renderOption={(option) => option?.property_name || ""}
              onChange={async (e, newValue) => {
                onSelectedChangeHandler("property", newValue || null);
                onStateChangeHandler(
                  "propertyId",
                  (newValue && newValue.id) || null
                );
                onStateChangeHandler(
                  "cityId",
                  (newValue &&
                    newValue &&
                    newValue.city &&
                    newValue.city.lookupItemId) ||
                    null
                );
                onStateChangeHandler(
                  "districtId",
                  (newValue &&
                    newValue &&
                    newValue.district &&
                    newValue.district.lookupItemId) ||
                    null
                );
                onStateChangeHandler(
                  "communityId",
                  (newValue &&
                    newValue &&
                    newValue.community &&
                    newValue.community.lookupItemId) ||
                    null
                );
              }}
              onInputKeyUp={(e) => {
                const { value } = e.target;
                if (searchTimer.current) clearTimeout(searchTimer.current);
                searchTimer.current = setTimeout(() => {
                  getAllProperty(value);
                }, 500);
              }}
            />
          </Box>
          <Divider />
        </>
      )}
      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("unit-type")}*
        </Typography>
        <CustomAutocomplete
          placeholder={translate("Select")}
          options={data?.unitType || []}
          onChange={(e, value) => {
            onSelectedChangeHandler("unitType", value || null);
            onStateChangeHandler(
              "unitTypeId",
              (value && value.lookupItemId) || null
            );
          }}
          value={selected?.unitType || null}
          getOptionLabel={(option) => option?.lookupItemName || ""}
          getOptionValue={(option) => option?.lookupItemId || ""}
          renderOption={(option) => option?.lookupItemName || ""}
        />
      </Box>
      <Divider />

      {(state.leadClassId === 1 || state.leadClassId === 2) && (
        <>
          <Box className={styles.containerItem}>
            <Typography className={styles.containerTitle}>
              {translate("Price")}*
            </Typography>
            <CustomInput
              placeholder={translate("Enter")}
              hasSearchIcon={false}
              value={state.priceFrom || ""}
              style={{ maxWidth: "100%" }}
              type="number"
              min={0}
              onChange={(event) => {
                onStateChangeHandler("priceFrom", +event.target.value || "");
              }}
            />
          </Box>
          <Divider />

          <Box className={styles.containerItem}>
            <Typography className={styles.containerTitle}>
              {translate("Area")}*
            </Typography>
            <CustomInput
              placeholder={translate("Enter")}
              hasSearchIcon={false}
              value={state.areaFrom || ""}
              style={{ maxWidth: "100%" }}
              type="number"
              min={0}
              onChange={(event) => {
                onStateChangeHandler("areaFrom", +event.target.value || "");
              }}
            />
          </Box>
          <Divider />
        </>
      )}

      {(state.leadClassId === 3 || state.leadClassId === 4) && (
        <>
          <Box className={styles.containerItem}>
            <Typography className={styles.containerTitle}>
              {translate("Price")}*
            </Typography>
            <CustomRangeSlider
              value={[
                Number(state?.priceFrom) ,
                Number(state?.priceTo) ,
              ]}
              handleChange={(e, newValue) => {
                onStateChangeHandler("priceFrom", newValue?.[0] || null);
                onStateChangeHandler("priceTo", newValue?.[1] || null);
              }}
              min={10000}
              max={60000000}
              valueLabelDisplay="off"
              preInputText={translate("AED")}
            />
          </Box>
          <Divider />

          <Box className={styles.containerItem}>
            <Typography className={styles.containerTitle}>
              {translate("Area")}*
            </Typography>
            <CustomRangeSlider
              value={[
                Number(state?.areaFrom) ,
                Number(state?.areaTo) ,
              ]}
              handleChange={(e, newValue) => {
                onStateChangeHandler("areaFrom", newValue?.[0] || null);
                onStateChangeHandler("areaTo", newValue?.[1] || null);
              }}
              min={200}
              max={10000}
              valueLabelDisplay="off"
              preInputText={translate("Ft")}
            />
          </Box>
          <Divider />
        </>
      )}

      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Beed-room")}
        </Typography>
        <CustomInput
          placeholder={translate("Enter")}
          hasSearchIcon={false}
          value={state.numberOfBedrooms || ""}
          style={{ maxWidth: "100%" }}
          type="number"
          min={0}
          onChange={(event) => {
            const list = [];
            if (event && event.target && event.target.value !== "")
              list.push(event.target.value);
            onStateChangeHandler("numberOfBedrooms", list);
          }}
        />
      </Box>
      <Divider />

      <Box className={styles.containerItem}>
        <Typography className={styles.containerTitle}>
          {translate("Bath-room")}
        </Typography>
        <CustomInput
          placeholder={translate("Enter")}
          hasSearchIcon={false}
          value={state.numberOfBathrooms || ""}
          style={{ maxWidth: "100%" }}
          type="number"
          min={0}
          onChange={(event) => {
            const list = [];
            if (event && event.target && event.target.value !== "")
              list.push(event.target.value);

            onStateChangeHandler("numberOfBathrooms", list);
          }}
        />
      </Box>
      
    </Box>
  );
};

export default MyLeadUnitDetailsFields;
